import React from 'react';

function PlayerAvatar({
  emoji = '🐶',
  name,
  levelNumber,
  levelEmoji,
  size = 32,
  showName = true,
  showLevel = true,
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        style={{
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '2em',
        }}
      >
        {emoji}
      </span>
      {showName && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontWeight: 700 }}>{name}</span>
          {showLevel && (
            <span
              style={{
                padding: '2px 4px',
                borderRadius: 999,
                fontSize: 12,
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.15)',
              }}
            >
              {levelEmoji} {levelNumber}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default PlayerAvatar;
